import { FC } from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { observer } from 'mobx-react-lite';

import { useTrans } from '@libs/i18n';
import { FileDashedIcon } from '@phosphor-icons/react';

interface Props {
  /** True when the list is non-empty but the active filter hides everything. */
  filtered?: boolean;
}

/** Centered placeholder shown when there are no documents to display. */
export const DocumentHubEmptyState: FC<Props> = observer(({ filtered }) => {
  const { t } = useTrans();
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        gap: 1,
        py: 8,
        px: 2,
      }}
    >
      <Box
        sx={{
          width: 48,
          height: 48,
          borderRadius: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'grey.200',
          mb: 0.5,
        }}
      >
        <FileDashedIcon size={24} color={theme.palette.text.tertiary} />
      </Box>
      <Typography variant="textMD_semiBold" color="text.primary">
        {filtered ? t('app.documentHub.empty.filtered') : t('app.documentHub.empty.title')}
      </Typography>
      {!filtered && (
        <Typography variant="textSM_regular" color="text.tertiary" sx={{ maxWidth: 420 }}>
          {t('app.documentHub.empty.body')}
        </Typography>
      )}
    </Box>
  );
});
